import { Component, OnInit, Input } from '@angular/core';
import { MarketplaceItemExtended, MarketplaceItemStatus, TEXT_COLOR, MARKETPLACE_STATE } from '@fgb/core';
import { DateTime } from 'luxon';

@Component({
  selector: 'fgbcl-marketplace-list-item',
  templateUrl: './marketplace-list-item.component.html',
  styleUrls: ['./marketplace-list-item.component.scss'],
})
export class MarketplaceListItemComponent implements OnInit {
  @Input() marketplaceItem: MarketplaceItemExtended;
  @Input() ignoreLink: boolean = false;
  @Input() featuredIcon: string = 'star';
  status = MarketplaceItemStatus;
  theme: string;
  statusText: string;
  stockAvailableState: string;
  textColor: string;
  MARKETPLACE = MARKETPLACE_STATE;
  constructor() {}

  ngOnInit() {
    this._updateTheme();
    if (this.marketplaceItem?.Status) this._updateStatusText();
    else this.getStockAvailableState();
  }

  getStockAvailableState() {
    [this.stockAvailableState, this.textColor] = this.handleStockAvailable(this.marketplaceItem);
  }

  private _updateStatusText() {
    switch (this.marketplaceItem?.Status) {
      case MarketplaceItemStatus.SoldOut:
        this.statusText = MARKETPLACE_STATE.SOLD_OUT;
        this.theme = 'sold-out';
        break;
      case MarketplaceItemStatus.NotEnoughPoints:
        this.statusText = MARKETPLACE_STATE.NOT_ENOUGH_POINT;
        this.theme = 'not-enough-points';
        break;
      case MarketplaceItemStatus.ComingSoon:
        this.statusText = MARKETPLACE_STATE.COMING_SOON;
        this.theme = 'coming-soon';
        break;
      case MarketplaceItemStatus.MemberLimitReached:
        this.statusText = MARKETPLACE_STATE.LIMIT_REACHED;
        this.theme = 'limit-reached';
        break;
      case MarketplaceItemStatus.AllInBasket:
        this.statusText = MARKETPLACE_STATE.ALL_IN_BASKET;
      default:
        return;
    }
  }

  private _updateTheme() {
    if (this.marketplaceItem?.Status === MarketplaceItemStatus.Available) this.theme = this.marketplaceItem?.theme;
    else this.theme = 'disabled';
  }

  private handleStockAvailable(marketplaceItem: MarketplaceItemExtended) {
    if (!marketplaceItem) return ['', this.theme];
    const stockCount = marketplaceItem.AvailabilityCount;
    // Limited stock
    if (stockCount > 5 && stockCount <= 10) return [MARKETPLACE_STATE.LIMITED, TEXT_COLOR.RED];

    // Stock count left
    if (stockCount > 0 && stockCount <= 5) return [MARKETPLACE_STATE.REMAINING, TEXT_COLOR.RED];

    // New Stock
    const startDate = DateTime.fromISO(marketplaceItem.ItemStartDate as string, { zone: 'utc' });

    const requestTime = DateTime.fromISO(marketplaceItem.RequestTime as string, { zone: 'utc' });
    const days = requestTime.diff(startDate, 'days').days;

    // New Stock
    const threeDays = 3;
    if (days <= threeDays) return [MARKETPLACE_STATE.NEW, TEXT_COLOR.NEW];

    // Stock Favourite
    if (marketplaceItem.Favourite) return [MARKETPLACE_STATE.FEATURED, TEXT_COLOR.GREEN];
    else return ['', this.theme];
  }

  get hasSponsor(): boolean {
    return !!this.marketplaceItem?.Sponsor?.SponsorImage;
  }
}
